import { Gapper } from '../../ui/utils';
import { CardPaper } from './styles';
import {
  CardsContainer,
  StepCardRow,
  NumberIconResponsive,
  CardContentWrapper,
  StepCardTitle,
  StepCardDescription,
} from '../StepCardLayout/styles';

const OnboardingCard = ({ title, description, number }) => {
  return (
    <CardPaper elevation={0}>
      <CardsContainer>
        <StepCardRow>
          <NumberIconResponsive>{number}</NumberIconResponsive>
          <CardContentWrapper>
            <StepCardTitle>{title}</StepCardTitle>
            <StepCardDescription>{description}</StepCardDescription>
          </CardContentWrapper>
        </StepCardRow>
      </CardsContainer>
    </CardPaper>
  );
};

export const OnboardingCardList = ({ cards }) => {
  return (
    <Gapper gap={18}>
      {cards.map((card) => (
        <OnboardingCard key={card.title} {...card} />
      ))}
    </Gapper>
  );
};

export default OnboardingCard;
